import classnames from "classnames";
import { TextareaHTMLAttributes } from "react";
import { FieldError, RegisterOptions, UseFormMethods } from "react-hook-form";
import "./TextAreaInput.style.scss";

interface TextAreaInputProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  register: UseFormMethods["register"];
  rules?: RegisterOptions;
  dataRecurly?: string;
  optional?: boolean;
  error?: FieldError;
  label?: string | JSX.Element;
  className?: string;
  help?: string;
  name: string;
}

export function TextAreaInput({
  register,
  dataRecurly,
  className,
  optional,
  error,
  rules,
  label,
  name,
  help,
  ...defaultAttributes
}: TextAreaInputProps) {
  return (
    <div className={`form-ctrl form-ctrl-text-area ${className || ""}`}>
      {label ? (
        <label className={classnames({ optional })} htmlFor={name}>
          {label}
        </label>
      ) : null}
      <textarea
        {...(dataRecurly ? { "data-recurly": dataRecurly } : {})}
        {...defaultAttributes}
        className={classnames({ "has-error": !!error })}
        aria-invalid={error ? "true" : "false"}
        ref={register(rules)}
        id={name}
        name={name}
      />
      {error ? <span className="form-error">{error.message || "Error"}</span> : null}
      {help ? <span className="form-help">{help}</span> : null}
    </div>
  );
}
